import React from 'react';
import WallabiesWarmCareBlanket from './WallabiesWarmCareBlanket';
import SurgicalBlankets from './SurgicalBlankets';


const Productwallabies = () => {
    return (
        <>

<div className="breadcrumbs overlay">
    <div className="container">
      <div className="bread-inner">
        <div className="row">
          <div className="col-12">
            <h2>PRODUCT WALLABIES WARM AIR BLANKETS</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
            <section>
               <WallabiesWarmCareBlanket/>
            <SurgicalBlankets/>
            </section>
        </>
    );
};

export default Productwallabies;
